export default __webpack_public_path__ + "static/media/recorder.4bf95249.png";